import { PlusOutlined, ShopOutlined } from '@ant-design/icons';
import { useAccess, useIntl } from '@umijs/max';
import { Button, Empty, Typography } from 'antd';

const { Text } = Typography;

interface EmptyMerchantsProps {
  onCreateMerchant?: () => void;
  /** Pre-rendered create buttons (e.g. per-profile split). Takes priority over onCreateMerchant. */
  createButtons?: React.ReactNode;
}

const EmptyMerchants: React.FC<EmptyMerchantsProps> = ({
  onCreateMerchant,
  createButtons,
}) => {
  const intl = useIntl();
  const access = useAccess();

  return (
    <Empty
      image={<ShopOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />}
      description={
        <div>
          <Text type="secondary" style={{ fontSize: 16 }}>
            {intl.formatMessage({ id: 'components.emptyMerchants.title' })}
          </Text>
          <br />
          <Text type="secondary">
            {intl.formatMessage({
              // Without the create button, "or create a new merchant" would be a
              // dead end — point those users at the platform admin instead.
              id: access.canCreatePartner
                ? 'components.emptyMerchants.description'
                : 'components.emptyMerchants.description.noPermission',
            })}
          </Text>
        </div>
      }
      style={{ padding: '60px 0' }}
    >
      {createButtons
        ? createButtons
        : access.canCreatePartner &&
          onCreateMerchant && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={onCreateMerchant}
            >
              {intl.formatMessage({
                id: 'components.emptyMerchants.createButton',
              })}
            </Button>
          )}
    </Empty>
  );
};

export default EmptyMerchants;
